<admin-header [primaryButtons]="headerPrimaryButtons" [title]="title" (eventFired)="headerButtonClick($event)"></admin-header>


<div class="knowledge-wrapper">
  <!-- Category Sidebar -->
  <div class="category-sidebar">
    <h3>Categories</h3>
    <ul>
      <li *ngFor="let cat of categories" (click)="filterCats(cat.name)">
		<span>{{ cat.name }}</span>
        <span [class.active] ="cat.name === this.selectedCat" [class.count] ="cat.name !== this.selectedCat" >{{ cat.count }}</span>
      </li>
    </ul>
  </div>

  <!-- Recent Articles Section -->
  <div class="recent-articles">
    <div class="recent-articles-header">
      <h2>Recent Articles <span *ngIf="this.selectedCat !== ''">{{"- " + this.selectedCat}}</span></h2>
	    <div class="search-section">
        <input
          type="text"
          placeholder="Search articles..."
          [(ngModel)]="keywords"
        />
        <button (click)="handleSubmit()">
          <i class="fas fa-search"></i> Search
        </button>
		<div class="clear">
		   <button (click)="clearSearch()">
          <i class="fas fa-times"></i> Clear
        </button>
		</div>
      </div>
      <!-- <div class="sort-section">
       <form action="/employee-page" (submit)="handleSubmit($event)">
	<dx-form action="" class="m-3" [(formData)]="formDetails" [showColonAfterLabel]="true" labelLocation="top" (onSubmit)="search" [colCount]="10">
		<dxi-item dataField="keywords" [colSpan]="9"><dxo-label [visible]="false"></dxo-label></dxi-item>
		<dxi-item itemType="button" [buttonOptions]="submitButtonOptions"></dxi-item>
	</dx-form>
</form>
      </div> -->
    </div>

    <div class="articles-grid">
      <div class="article-card" *ngFor="let article of filteredItems">
		<a href="/admin/help/{{article.id}}" style="text-decoration: none;">
        <div class="article-header">
          <span class="badge blue">{{ article.section }}</span>
          <span class="date">{{ article.date }}</span>
        </div>
        <h4>{{ article.title }}</h4>
        <p>{{ article.description }}</p>
        <div class="article-footer">
          <div class="stats">
            <span><i class="fas fa-tag"></i> {{ article.tags }}</span>
          </div>
          <div class="author">
            <img [src]="renderAuthor(article.authorId)" alt="Author {{renderAuthorName(article.authorId)}}">
            <span>{{ renderAuthorName(article.authorId) }}</span>
          </div>
        </div>
		</a>
      </div>
    </div>
  </div>
</div>